import React from 'react';

import Dartboard from './Dartboard';

const DartsScoreboard = ({logout}) => {
    function handleClick(event) {
    }

    return <div style={{marginTop: "50px"}}>
        <Dartboard onclick={handleClick} />
    </div>;
};

export default DartsScoreboard;